import { render, staticRenderFns } from "./special.vue?vue&type=template&id=664e0649&scoped=true"
import script from "./special.vue?vue&type=script&lang=ts"
export * from "./special.vue?vue&type=script&lang=ts"
import style0 from "./special.vue?vue&type=style&index=0&id=664e0649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e0649",
  null
  
)

export default component.exports